import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.293 14.707a1 1 0 0 0 1.414-1.414zM4 9l-.707-.707a1 1 0 0 0 0 1.414zm5.707-4.293a1 1 0 0 0-1.414-1.414zM19 20a1 1 0 1 0 2 0zM16 9V8zm-6.293 4.293-5-5-1.414 1.414 5 5zm-5-3.586 5-5-1.414-1.414-5 5zM21 20v-7h-2v7zm0-7a5 5 0 0 0-1.465-3.536l-1.414 1.415A3 3 0 0 1 19 13zm-1.465-3.536A5 5 0 0 0 16 8v2a3 3 0 0 1 2.121.879zM16 8H4v2h12z"
    />
  </svg>
);
export default SvgCornerUpLeft;
